export default function PHP_ob_flush() {
  return (
    <div>
      <h1>PHP_ob_flush</h1>
    </div>
  );
}
